exports = module.exports = require("../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".classificationMainView{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}@media (min-width: 992px){._2985r2TqUVgi9zSyrmCTgh{max-height:none}}._1iKQWjZWEqd3xMh7JPKNAS{text-align:center;background:linear-gradient(315deg, #0070ce 0%, #00baff 100%)}._1iKQWjZWEqd3xMh7JPKNAS img{max-width:21.42857rem;margin:1rem auto 0}\n", ""]);

// exports
exports.locals = {
	"successMainView": "_2985r2TqUVgi9zSyrmCTgh",
	"headerLayout": "_1iKQWjZWEqd3xMh7JPKNAS"
};